import React from 'react'
import moment from 'moment'

import { reports } from '../../core/controllers/Reports';
import NavLink from '../Routes/NavLink'

export default class BasicStatsWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

        reports.getBasicStats(function(response) {
            var stats = response.data;

            var chart = new Chartist.Line('.ct-chart', {
                labels: [moment().subtract(2,'months').format('MMMM'), moment().subtract(1,'months').format('MMMM'), moment().format('MMMM')],
                series: [{
                        name: 'Leases Expired',
                        data: stats.leases_expired
                    },
                    {
                        name: 'Submitted Work Orders',
                        data: stats.submitted_work_orders
                    },
                    {
                        name: 'Completed Work Orders',
                        data: stats.completed_work_orders
                    }
                ]
              }, {
                low: 0,
                showArea: false,
                showPoint: true,
                fullWidth: true
              });

              chart.on('draw', function(data) {
                if(data.type === 'line' || data.type === 'area') {
                  data.element.animate({
                    d: {
                      begin: 2000 * data.index,
                      dur: 2000,
                      from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
                      to: data.path.clone().stringify(),
                      easing: Chartist.Svg.Easing.easeOutQuint
                    }
                  });
                }
              });

            var $tooltip = jQuery('<div class="tooltip tooltip_custom tooltip-hidden"></div>').appendTo(jQuery('.ct-chart'));

            jQuery(document).on('mouseenter', '.ct-point', function() {
                var seriesName = jQuery(this).closest('.ct-series').attr('ct:series-name'),
                    value = jQuery(this).attr('ct:value');

                $tooltip.text(seriesName + ': ' + value);
                $tooltip.removeClass('tooltip-hidden');
            });

            jQuery(document).on('mouseleave', '.ct-point', function() {
                $tooltip.addClass('tooltip-hidden');
            });

            jQuery(document).on('mousemove', '.ct-point', function(event) {
                $tooltip.css({
                    left: event.offsetX - $tooltip.width() / 2,
                    top: event.offsetY - $tooltip.height()
                });
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        return (
            <div class="col-md-7">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Basic Stats</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                <div id="line-chart" class="ct-chart"></div>
                            </div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="card-footer">
                            <div class="legend">
                                <i class="fa fa-circle graph-a"></i> Leases Expired
                                <i class="fa fa-circle text-danger"></i> Submitted Work Orders
                                <i class="fa fa-circle text-warning"></i> Completed Work Orders
                            </div>
                            <hr/>
                            <div class="stats">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Reports/BasicStatsWidget.jsx